module.exports = __webpack_public_path__ + "img/sz.da6569e.svg";